import Blue from '~/core'

new Blue({
  name: 'site modals',
  selector: '.site-modals__cookies',
  setup(container) {
    const accept = container.querySelector('.cookies__btn-accept')
    const decline = container.querySelector('.cookies__btn-decline')
    const storage = window.localStorage

    const closeCookies = () => {
      container.classList.remove('site-modals__cookies--active')
    }

    const setCookies = async (consent) => {
      if (consent) {
        await fetch('/api/cookies/consent', {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
          },
          redirect: 'follow',
          referrerPolicy: 'no-referrer',
          body: JSON.stringify(consent),
        })

        await loadOptInGtm()
      }

      storage.setItem('acceptedCookies', JSON.stringify(consent))
      closeCookies()
    }

    const loadOptInGtm = async () => {
      // first remove existing node
      let gtmResponse = await fetch('/api/cookies/gtmoptin', {
        method: 'POST',
      })

      let gtm = await gtmResponse.text()
      let node = document.createElement('script')
      node.textContent = gtm
      node.type = 'text/javascript'
      node.async = true
      node.charset = 'utf-8'
      node.setAttribute('id', 'tagmanager_optin')
      document.getElementsByTagName('head')[0].appendChild(node)
    }

    if (storage.getItem('acceptedCookies') === null) {
      setTimeout(() => {
        container.classList.add('site-modals__cookies--active')
        accept.setAttribute('tabindex', 1)
        decline.setAttribute('tabindex', 1)
      }, 1000)
    }

    if (storage.getItem('acceptedCookies') === 'true') {
      loadOptInGtm()
    }

    this.$addEvents(accept, 'click', () => {
      setCookies(true)
    })
    this.$addEvents(decline, 'click', () => {
      setCookies(false)
    })
  },
})

new Blue({
  name: 'site modals',
  selector: '.site-modals__cookies-alert',
  setup(container) {
    const accept = container.querySelector('.cookies-alert__btn-accept')
    const decline = container.querySelector('.cookies-alert__btn-decline')
    const storage = window.localStorage

    const showModal = () => {
      container.classList.add('site-modals__cookies-alert--active')
    }
    const hideModal = () => {
      container.classList.remove('site-modals__cookies-alert--active')
    }

    const setCookies = async (consent) => {
      if (consent) {
        await fetch('/api/cookies/consent', {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
          },
          redirect: 'follow',
          referrerPolicy: 'no-referrer',
          body: JSON.stringify(consent),
        })

        await loadOptInGtm()
      }

      storage.setItem('acceptedCookies', JSON.stringify(consent))
      hideModal()
    }

    const loadOptInGtm = async () => {
      // first remove existing node
      let gtmResponse = await fetch('/api/cookies/gtmoptin', {
        method: 'POST',
      })

      let gtm = await gtmResponse.text()
      let node = document.createElement('script')
      node.textContent = gtm
      node.type = 'text/javascript'
      node.async = true
      node.charset = 'utf-8'
      node.setAttribute('id', 'tagmanager_optin')
      document.getElementsByTagName('head')[0].appendChild(node)
    }

    if (storage.getItem('acceptedCookies') === 'false') {
      setTimeout(() => {
        showModal()
        accept.setAttribute('tabindex', 1)
        decline.setAttribute('tabindex', 1)
      }, 1000)
    }

    this.$addEvents(accept, 'click', () => {
      setCookies(true)
    })
    this.$addEvents(decline, 'click', () => {
      setCookies(false)
    })
  },
})
